var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthquake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8889C3 5.97969 7.02944 2 12 2C16.9706 2 21 5.97969 21 10.8889C21 11.01 20.9974 11.1304 20.9922 11.25H17.6594C17.5594 11.25 17.469 11.1904 17.4296 11.0985L15.5465 6.70456C15.4258 6.42301 15.1461 6.24314 14.8398 6.2502C14.5336 6.25726 14.2625 6.44984 14.1549 6.73666L11.7588 13.1263L9.52796 8.66459C9.41033 8.42932 9.17804 8.27287 8.91581 8.2523C8.65358 8.23172 8.39973 8.35003 8.24684 8.56407L6.32832 11.25H3.00783C3.00264 11.1304 3 11.01 3 10.8889Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21011 12.75C4.19837 17.0966 8.45184 20.2336 11.2201 21.6333C11.7123 21.8821 12.2877 21.8821 12.7799 21.6333C15.5482 20.2336 19.8016 17.0966 20.7899 12.75H17.6594C16.9593 12.75 16.3267 12.3328 16.0509 11.6894L14.9036 9.01224L12.5594 15.2633C12.4546 15.5427 12.1943 15.7333 11.8965 15.749C11.5986 15.7646 11.3197 15.6022 11.1863 15.3354L8.74341 10.4496L7.32459 12.4359C7.1838 12.633 6.9565 12.75 6.71429 12.75H3.21011Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake);
export default __webpack_public_path__ + "static/media/earthquake.8273cf78171d1382c8389b849bbe26d0.svg";
export { ForwardRef as ReactComponent };